import { dateYMDHMS } from '@/filters/date'
import homeUIConfig from '@/common/homeUIConfig'

export default {
  // APP
  device: (state) => state.app.device,
  sidebar: (state) => state.app.sidebar,
  dialogKf: (state) => state.app.dialogKf,
  is_oem: (state) => state.app.is_oem,
  oem_logo: (state) => state.app.oem_logo,


  // 路由表
  permission_routers: (state) => state.permission.routers,  // 所有路由表(不需要权限&符合权限的路由表)
  addRouters: (state) => state.permission.addRouters, // 符合权限的路由表


  // 用户登录
  user_id: (state) => state.user.info.id,
  name: (state) => state.user.info.taobao_nickname,
  user_info: (state) => state.user.info,
  token: (state) => state.user.token,
  roles: (state) => state.user.roles,
  user_vip: (state) => state.user.info.vip - 0,  // cms等级 0未开通 1导购版 2用户中心版 3返利代理版 4尊享版
  vipCN: (state) => ['免费版', '导购版', '用户中心版', '返利代理版', '尊享版'][state.user.info.vip - 0],
  getVipCN: () => (vip = 0) => ['免费版', '导购版', '用户中心版', '返利代理版', '尊享版'][vip],
  money_total: (state) => state.user.info.money_total,  // 推币余额


  // cms信息
  cms_info: (state) => state.cmsInfo.info,
  cms_activate: (state) => state.user.info.vip - 0 > 0,
  isOpen: (state) => state.cmsInfo.isOpen,  // 是否开通过cms
  activate: (state) => state.cmsInfo.activate,

  // 会员版本
  verConfig: (state) => state.config.verConfig,

  // 标记提醒
  badge: (state) => state.badge,


  // oem
  isOEM: (state) => state.oem.isOEM,
  logo: (state) => state.oem.logo,
  oemID: (state) => state.oem.id,
  title: (state) => state.oem.title,

  // 弹屏广告
  popupwin: (state) => pluginKeys([
    'popupwin_ad_text',
    'popupwin_bg_picture',
    'popupwin_button_text',
    'popupwin_button_url',
    'popupwin_open',
    'popupwin_time_begin',
    'popupwin_time_end',
    'popupwin_type',
  ], state),

  // 签到功能插件
  pluginCheckin: (state) => pluginKeys([
    'plugin_checkin_base_above_money',
    'plugin_checkin_base_below_money_range_max',
    'plugin_checkin_base_below_money_range_min',
    'plugin_checkin_base_days',
    'plugin_checkin_expires_at',
    'plugin_checkin_updatetime',
  ], state),

  // 搜索接口插件
  pluginSearch: (state) => pluginKeys([
    'plugin_search_expires_at',
    'plugin_search_url',
    'plugin_search_kuaiurl',
  ], state),

  // 域名服务插件
  pluginDomain: (state) => pluginKeys([
    'plugin_domain_expires_at',
    'domain',
  ], state),

  // 官方红包插件
  pluginGFredpack: (state) => pluginKeys([
    'plugin_gfhb_expires_at',
    'plugin_gfhb_title',
    'plugin_gfhb_picture',
    'plugin_gfhb_ad_text',
    'plugin_gfhb_content',
    'plugin_gfhb_time_begin',
    'plugin_gfhb_time_end',
    'plugin_gfhb_share_url',
    'plugin_gfhb_button_url',
    'plugin_gfhb_button_text',
  ], state),

  // 推广小店
  pluginTgstore: (state) => pluginKeys([
    'plugin_tgxd_ad_text',
    'plugin_tgxd_expires_at',
    'plugin_tgxd_share_url',
    'plugin_tgxd_share_url_qr_code',
  ], state),

  // 提现红包
  pluginTXHB: (state) => pluginKeys([
    'plugin_txhb_amount1',
    'plugin_txhb_amount2',
    'plugin_txhb_amount3',
    'plugin_txhb_amount4',
    'plugin_txhb_amount5',
    'plugin_txhb_day1',
    'plugin_txhb_day2',
    'plugin_txhb_day3',
    'plugin_txhb_day4',
    'plugin_txhb_day5',
    'plugin_txhb_money1',
    'plugin_txhb_money2',
    'plugin_txhb_money3',
    'plugin_txhb_money4',
    'plugin_txhb_money5',
    'plugin_txhb_expires_at',
    'plugin_txhb_lastupdate',
  ], state),

  // 一键登录
  pluginFastlogin: (state) => pluginKeys([
    'plugin_wxlogin_expires_at',
    'plugin_wxlogin_wxappid',
    'plugin_wxlogin_wxappscrectkey',
    'plugin_wxlogin_wxauth_filename',
  ], state),

  // 零元购
  pluginLYG: (state) => pluginKeys([
    'plugin_lyg_kuaiurl',
    'plugin_lyg_ad_rule',
    'plugin_lyg_ad_text',
    'plugin_lyg_bgimg',
    'plugin_lyg_coupon_quota',
    'plugin_lyg_expires_at',
    'plugin_lyg_newuser_coupon_amt',
    'plugin_lyg_olduser_coupon_amt',
    'plugin_lyg_olduser_coupon_quota',
    'plugin_lyg_taobao_auth',
    'plugin_lyg_time_begin',
    'plugin_lyg_time_end',
    'plugin_lyg_updatetime',
    'plugin_lyg_use_limit_days',
    'plugin_lyg_use_limit_times',
    'plugin_lyg_open',
  ], state),

  // 限时抢购
  pluginFlashsale: (state) => pluginKeys([
    'plugin_flashsale_expires_at',
    'plugin_flashsale_kuaiurl',
  ], state),

  // 超级秒杀
  pluginXSMS: (state) => pluginKeys([
    'plugin_xsms_expires_at',
    'plugin_xsms_item_source',
    'plugin_xsms_reward_lock_day',
    'plugin_xsms_use_limit_day',
    'plugin_xsms_use_limit_num',
    'plugin_xsms_kuaiurl',
    'plugin_xsms_open',
    'plugin_xsms_detail',
  ], state),

  //返利机器人
  pluginFljqr: (state) => pluginKeys([
    'plugin_fljqr_expires_at',
  ], state),

  //服务号消息
  pluginWxloginTmpmsg: (state) => pluginKeys([
    'plugin_wxlogin_tmpmsg_expires_at',
  ], state),

  //公众号关键词找券
  pluginWxautoreply: (state) => pluginKeys([
    'plugin_wxautoreply_expires_at',
    'plugin_wxautoreply_gzhid',
    'plugin_wxautoreply_token',
  ], state),

  //导购APP
  pluginAppManage: (state) => pluginKeys([
    'plugin_app_expires_at',
  ], state),

  // 微信小程序
  pluginWxapp: (state) => pluginKeys([
    'plugin_wxapp_expires_at',
  ], state),

  // cms店铺装修数据
  cms_ui_config: ({ cmsInfo }) => {
    const { cms_ui_config } = cmsInfo.info
    if (!cms_ui_config) {
      return [homeUIConfig()]
    } else {
      let conf = null
      try {
        conf = JSON.parse(cms_ui_config)
      } catch(err) {
        conf = null
      }
      return conf || [homeUIConfig()]
    }
  },
}


/**
 *
 * @param {String} keys 需要的键值
 * @param {Object} state cms_info
 */
function pluginKeys(keys, state) {
  const { info } = state.cmsInfo
  const result = {}
  keys.forEach((key) => {
    result[key] = info[key]
    if (result[key] === undefined) {
      result[key] = ''
    }
  })

  const expires_at = keys.find((k) => k.includes('expires_at'))
  if (expires_at) {
    result.expires = dateYMDHMS(info[expires_at] * 1000)
  }

  return result
}
